<template>
    <div class="block-testimonials__container">
        <v-carousel 
                    cycle
                    show-arrows 
                    next-icon="mdi-chevron-right" 
                    prev-icon="mdi-chevron-left"
                    hide-delimiters
                    height="auto"
                    class="block-testimonials pt-6 pt-md-10 mb-12 pb-lg-12"
            >
            <template v-slot:prev="{ on, attrs }">
                <img src="../../src/assets/icons/chevron-left.svg" alt="icon arrow" v-bind="attrs" v-on="on">
            </template>
            <template v-slot:next="{ on, attrs }">
                <img src="../../src/assets/icons/chevron-right.svg" alt="icon arrow" v-bind="attrs" v-on="on">
            </template>
            <v-carousel-item v-for="(testimonial, i) in testimonialsData" :key="i" class="mb-4">
                <v-sheet height="100%" color="#fff">
                    <v-row>
                        <v-col cols="12" class="py-0 px-0">
                            <div>
                                <p>“{{testimonial.quote}}”</p>
                                <h3>— {{testimonial.name}}</h3>
                            </div>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script>

export default {
    name: 'TestimonialsCarousel',
    props: ['testimonialsData'],
}
</script>

<style>
.home-testimonials .v-window__next .v-btn:after,
.home-testimonials .v-window__prev .v-btn:after {
    position: absolute;
    content: '';
    width: 16px;
    height: 30px;
    transform: scale(1.1);
}

.home-testimonials .v-window__prev {
    margin: 0 12px 0 -10px;
    background: none;
    cursor: pointer;
}

.home-testimonials .v-window__next {
    margin: 0 -10px 0 0;
    background: none;
    cursor: pointer;
}

.home-testimonials .v-window__prev .v-btn:after {
    background-image: url("../../src/assets/icons/chevron-left.svg");
}

.home-testimonials .v-window__next .v-btn:after {
    background-image: url("../../src/assets/icons/chevron-right.svg");
}
.block-testimonials__container .v-window__next .v-btn,
.block-testimonials__container .v-window__prev .v-btn {
    position: relative;
}

.block-testimonials__container .v-window__next .v-btn:after,
.block-testimonials__container .v-window__prev .v-btn:after {
    position: absolute;
    content: '';
    width: 16px;
    height: 30px;
    transform: scale(1.1);
}

.block-testimonials__container .v-window__prev {
    margin: 0 12px 0 0;
    background: none!important;
    cursor: pointer;
}

.block-testimonials__container .v-window__next {
    margin: 0;
    background: none !important;
    cursor: pointer;
}

.block-testimonials__container .v-window__prev .v-btn:after {
    background-image: url("../../src/assets/icons/chevron-left.svg");
}

.block-testimonials__container .v-window__next .v-btn:after {
    background-image: url("../../src/assets/icons/chevron-right.svg");
}

.block-testimonials .v-window-item {
    max-width: 796px;
    margin: auto;
    color: #fff;
    box-shadow: 0px 4px 44px rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 0px 0px;
    padding: 0;
}

.v-window__next .v-btn,
.v-window__prev .v-btn {
    position: relative;
}
.block-testimonials {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
}
.block-testimonials .v-window-item .col-12 p {
    padding: 73px 70px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 30px;
    /* or 167% */
    color: #000000;
}

.block-testimonials .v-window-item {
    position: relative;
    box-shadow: 0px 0px 15px 0px #0000001a;
    border-radius: 10px;
    overflow: hidden;
}

.block-testimonials .v-window-item:before {
    position: absolute;
    content: "";
    width: 75px;
    height: 75px;
    right: 5%;
    bottom: 24px;
    z-index: 1;
    /* White */

    background: #FFFFFF;
    box-shadow: 0px 0px 10.9091px rgba(0, 0, 0, 0.25);
    border-radius: 98.1818px;
}

.block-testimonials .v-window-item:after {
    position: absolute;
    content: "";
    width: 36px;
    height: 25px;
    right: 60px;
    bottom: 48px;
    z-index: 2;
    background-image: url("../../src/assets/icons/coma-icom.svg"); 
}
.block-testimonials .v-window-item .col-12 P {
    font-size: clamp(14px, 4vw, 16px);
    line-height: 1.625;
}
.block-testimonials .v-window-item .col-12 h3 {
    padding: 20px 24px 28px 32px;
    background: #2D76E3;
    border-radius: 0px 0px 10px 10px;
    color: #fff;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: clamp(14px, 2vw, 16px);
    line-height: 1.625;
    /* identical to box height, or 169% */

    letter-spacing: 1.5px;
    text-transform: uppercase;
}
@media (max-width: 991px) {
    .block-testimonials__container .v-window__container {
        width: 90%;
        margin: auto;
    }

    .block-testimonials .v-window-item .col-12 p {
        padding: 53px 50px;
    }
    .block-testimonials .v-window-item:before {
        position: absolute;
        content: "";
        width: 60px;
        height: 60px;
        bottom: 30px;
        right: 47px;
    }
    .block-testimonials .v-window-item:after {
        transform: scale(.7);
        bottom: 47px;
    }
}
@media (max-width: 767px) {
    .block-testimonials .v-window-item:before {
        right: 12px;
    }
    .block-testimonials .v-window-item:after {
        right: 25px;
    }
    .block-testimonials .v-window-item .col-12 h3 {
        padding: 20px 80px 28px 32px;
    }
}
@media (max-width: 575px) {
    .block-testimonials .v-window-item .col-12 p {
        padding: 50px 40px;
    }

}

@media (max-width: 560px) {
    .block-testimonials .v-window-item .col-12 p {
        width:90%;
        margin-left:30px;
        font-size: 14px;
        line-height: 1.7;
    }
    .block-testimonials__container .v-window__prev {
        margin: 0 0px 0 12px;
        background: none!important;
        cursor: pointer;
    }
    .block-testimonials__container .v-window__next {
        margin: 0 12px 0 0;
        background: none!important;
        cursor: pointer;
    }
}
</style>